import { Divider, List } from 'antd';
import { ListItemMetaProps } from 'antd/lib/list/Item';
import React from 'react';
import { components } from 'react-select';
import styled, { css } from 'styled-components';
import { SingleLineEllipsis } from 'components/styles';
import { DuplicateTaskConstants as Constant } from './constant';

const NonProjectActivity = styled.div<{ isSelected }>`
  margin: 0 var(--spacing-05);
  ${({ isSelected }) =>
    isSelected
      ? css`
          color: var(--white-100);
        `
      : css`
          color: var(--blue-60);
        `};
`;

const ListItem = styled(List.Item)`
  padding: 0;
`;

type MetaProps = ListItemMetaProps & {
  isFocused: boolean;
  isSelected: boolean;
};

const ListItemMeta = styled(List.Item.Meta)<MetaProps>`
  align-items: center;
  & .ant-list-item-meta-title {
    margin-bottom: 0;
    ${({ isSelected }) =>
      isSelected
        ? css`
            color: var(--white-100) !important;
          `
        : css`
            color: var(--gray-100);
          `};
  }
  & .ant-list-item-meta-description {
    font-size: var(--font-size-sm);
    ${({ isSelected }) =>
      isSelected
        ? css`
            color: var(--white-100);
          `
        : css`
            color: var(--gray-100);
          `};
    font-weight: normal;
    ${SingleLineEllipsis};
  }
`;

export const ProjectPhaseComponent = (props) => {
  const { data, isSelected, getStyles, ...restProps } = props;

  return (
    <>
      {data.value === Constant.notAssociatedWithAnyPhase ? (
        <>
          <components.Option
            getStyles={(a, b) => {
              return { ...getStyles(a, b), marginTop: 'var(--spacing-03)' };
            }}
            data={data}
            isSelected={isSelected}
            {...restProps}
          >
            <NonProjectActivity isSelected={isSelected}>
              {data.label}
            </NonProjectActivity>
          </components.Option>
          <Divider
            style={{
              margin: 'var(--spacing-05)',
              minWidth: 'cal(100% - 2 * var(--spacing-05))',
              width: 'cal(100% - 2 * var(--spacing-05))',
            }}
          />
        </>
      ) : (
        <>
          <components.Option {...props}>
            <ListItem>
              <ListItemMeta
                isFocused={isSelected}
                isSelected={isSelected}
                title={data.label}
                description={data.description}
              />
            </ListItem>
          </components.Option>
        </>
      )}
    </>
  );
};
